import paymentMethod from './payment-method.vue'
export type { PaymentMethodProps } from './props'
export default paymentMethod